/**
 * Helpers for nested master FKs on shipment unit GET responses
 * (shipping_company, origin_warehouse, destination_warehouse).
 * Write payloads still expect integer PKs only.
 */

/**
 * Coerce a nested `{ id }` / numeric id / numeric string into an integer PK.
 * @param {unknown} value
 * @returns {number|null}
 */
export function toNestedMasterFkPk(value) {
  if (value == null || value === '') return null;
  let raw = value;
  if (typeof value === 'object' && value !== null) {
    raw = value.id != null ? value.id : value.pk;
  }
  if (raw == null || raw === '') return null;
  const n = typeof raw === 'number' ? raw : Number(raw);
  return Number.isFinite(n) ? n : null;
}

/**
 * Normalize GET nested master object (or legacy bare id) for Autocomplete options.
 * @param {unknown} value - nested `{ id, name, name_ar, code, ... }` or numeric id
 * @returns {{ id: number, [key: string]: unknown }|null}
 */
export function nestedMasterOptionFromApi(value) {
  if (value == null || value === '') return null;
  if (typeof value === 'object' && !Array.isArray(value)) {
    const id = toNestedMasterFkPk(value);
    if (id == null) return null;
    return { ...value, id };
  }
  const id = toNestedMasterFkPk(value);
  if (id == null) return null;
  return { id };
}

/**
 * True when the option already has a usable display name (skip extra GET).
 * @param {{ name?: unknown, name_ar?: unknown }|null|undefined} opt
 * @returns {boolean}
 */
export function nestedMasterOptionHasName(opt) {
  if (!opt) return false;
  return Boolean(
    (opt.name != null && String(opt.name).trim())
    || (opt.name_ar != null && String(opt.name_ar).trim())
  );
}
